module.exports = __webpack_public_path__ + "static/media/stx_logo.66e231cc.png";